import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import {
  LocationStrategy,
  HashLocationStrategy,
  isPlatformBrowser,
} from '@angular/common';
import { LocalStorageService } from 'src/app/service/Local-storage.service';

@Component({
  selector: 'trpx-activity-card',
  templateUrl: './activity-card.component.html',
  styleUrls: ['./activity-card.component.scss'],
})
export class ActivityCardComponent implements OnInit {
  @Input() activityCards: any;

  productSlug = '';
  showInfoText: { [key: string]: boolean } = {};
  hostUrl: any;
  selectedCountryCode!: string | null;
  selectedCountry!: string | null;
  selectedCurrency!: string | null;

  constructor(
    private router: Router,
    private locationStrategy: LocationStrategy,
    private localStorageService: LocalStorageService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.localStorageService.countryCodelocalSubject$.subscribe(
      (countrySaved: any) => {
        // let countryDetlsState;
        // cotryDtlsDataChnl.onmessage = (event) => {
        //   if (event.data) {
        //     countryDetlsState = JSON.parse(event.data);
        //     console.log('Received message:', countryDetlsState);
        //   }
        // };

        this.selectedCountryCode = countrySaved;
      }
    );

    this.localStorageService.currencyLocalSubject$.subscribe(
      (courrencySaved: any) => {
        this.selectedCurrency = courrencySaved;
      }
    );
  }
  ngOnInit(): void {}

  // openLink(productSlug: string) {
  //   // console.log('testing,,,,', this.selectedCountry);
  //   // console.log('testing,,,,', this.selectedCurrency);
  //   // let passCounData = JSON.stringify(this.selectedCountry);
  //   // let passCurrData = JSON.stringify(this.selectedCurrency);

  //   let passCounData = this.selectedCountry;
  //   let passCurrData = this.selectedCurrency;
  //   let urlTree: UrlTree = this.router.createUrlTree(
  //     [`/product/${productSlug}`],
  //     {
  //       queryParams: {
  //         country: passCounData,
  //         currency: passCurrData,
  //       },
  //     }
  //   );
  //   let url: string = this.router.serializeUrl(urlTree);

  //   if (this.locationStrategy instanceof HashLocationStrategy) {
  //     const baseHref = this.locationStrategy.getBaseHref();
  //     url = `${baseHref}#${url}`;
  //   }
  //   if (isPlatformBrowser(this.platformId)) {
  //     this.hostUrl = window.location.origin;
  //   }
  //   // window.open(url, '_blank');
  //   return `${this.hostUrl}${url}`;
  // }

  openLink(productSlug: string): string {
    if (!productSlug) return '#'; // Avoid errors if no slug is available
  
    let passCounData = this.selectedCountryCode;
    let passCurrData = this.selectedCurrency;
  
    let urlTree: UrlTree = this.router.createUrlTree(
      [`/product/${productSlug}`],
      {
        queryParams: {
          country: passCounData,
          currency: passCurrData,
        },
      }
    );
  
    let url: string = this.router.serializeUrl(urlTree);
  
    if (this.locationStrategy instanceof HashLocationStrategy) {
      const baseHref = this.locationStrategy.getBaseHref();
      url = `${baseHref}#${url}`;
    }
  
    if (isPlatformBrowser(this.platformId)) {
      this.hostUrl = window.location.origin;
    }
  
    return `${this.hostUrl}${url}`;
  }
  
  
}
